import { useSidebarNavigation } from '@/contexts/sidebarNavigationContext';

import { useNavigate } from 'react-router-dom';
import ProfileBackSnackBar from '@/components/shared/ProfileBackSnackBar';

const BackToPlayBookBtn = () => {
  const navigate = useNavigate();
  const { secondarySidebarData, updateValue } = useSidebarNavigation();

  const onBackButtonClick = (to, state) => {
    updateValue('secondarySidebarData', {
      ...secondarySidebarData,
      backButton: null,
    });

    navigate(to, { state });
  };
  return (
    <>
      {secondarySidebarData.backButton && (
        <ProfileBackSnackBar
          current='Brand Profile'
          styles={{
            container: {
              bottom: '85px',
            },
          }}
          handleClick={() =>
            onBackButtonClick(
              secondarySidebarData.backButton.to,
              secondarySidebarData.backButton.state,
            )
          }
          title='Back to playbook'
          open={true}
        />
      )}
    </>
  );
};

export default BackToPlayBookBtn;
